/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryBestPracticeStatus extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryBestPracticeStatus");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryBestPracticeStatus.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryBestPracticeStatus>): AssessmentViewQueryBestPracticeStatus {
        let obj = Object.assign(new AssessmentViewQueryBestPracticeStatus(), model);
        AssessmentViewQueryBestPracticeStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryBestPracticeStatus>): AssessmentViewQueryBestPracticeStatus {
        if (!model) return null;
        return AssessmentViewQueryBestPracticeStatus.newInstance(<AssessmentViewQueryBestPracticeStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryBestPracticeStatus) {
        if (!obj) return;

        models.AssessmentViewQueryBestPracticeStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryBestPracticeStatus): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryBestPracticeStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Status of best practice
     */
    best_practice_statuses: Array<models.WellArchitectedFrameworkAssessmentRunAnswerStatus>;

}
